import {isRegressionsEnabled} from 'analysis-tool/AnalysisToolFeatureGates';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ConfigEditorStepType} from 'pipelines/generalized-step-config-editor/stepTypeIsConfigEditorSupported';
import * as Colors from 'ui-library/Colors';

/*
 * The `ADDABLE_TRANSFORMATION_STEPS` is organized as a list of lists to allow for sectioning in the dropdown.
 * Within each section, the order is sorted alphabetically by the corresponding value in `STEP_TYPE_TO_USER_FACING_NAME`
 */
export const ADDABLE_TRANSFORMATION_STEPS = [
  // Filter transformation
  [{stepType: PipelineStepType.FILTER_DATASET, stepVersion: 0}],
  // Simple transformations
  [
    {stepType: PipelineStepType.HIDE_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.REORDER_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.SORT_COLUMNS, stepVersion: 0},
  ],
  // Column transformations
  [
    {stepType: PipelineStepType.COMPUTED_COLUMN, stepVersion: 0},
    {stepType: PipelineStepType.WINDOW_FUNCTIONS, stepVersion: 0},
  ],
  [
    // Aggregations
    {stepType: PipelineStepType.AGGREGATE_DATASET, stepVersion: 0},
    {stepType: PipelineStepType.BIN_DATA, stepVersion: 0},
    {stepType: PipelineStepType.PIVOT_DATASET, stepVersion: 0},
    {stepType: PipelineStepType.UNPIVOT_DATASET, stepVersion: 0},
  ],
  [
    // Misc, table management, supposed to be rarely used
    {stepType: PipelineStepType.FIND_AND_REPLACE, stepVersion: 0},
    {stepType: PipelineStepType.FORMAT_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.RENAME_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.RETYPE_COLUMNS, stepVersion: 0},
  ],
  // Not widely available
  isRegressionsEnabled() ? [{stepType: PipelineStepType.REGRESSION_INTERPOLATION, stepVersion: 0}] : [],
] as const satisfies ReadonlyArray<ReadonlyArray<{stepType: ConfigEditorStepType; stepVersion: number}>>;

const STEPS_PADDING = 4;

export const SHARED_CONFIRMATION_BUTTON_STYLES = {
  marginLeft: 10,
  marginRight: 10,
};

export const SHARED_RIGHT_PANE_FOOTER_STYLES = {
  background: Colors.WHITE,
  alignSelf: 'flex-end' as const,
  borderTop: `1px solid ${Colors.GRAY_LIGHT}`,
  display: 'flex' as const,
  justifyContent: 'flex-end' as const,
  position: 'sticky' as const,
  bottom: 0,
  paddingTop: 15,
  paddingBottom: 15,
  width: '100%',
};

export const SHARED_RIGHT_PANE_STYLES = {
  display: 'flex' as const,
  flexDirection: 'column' as const,
  height: '100%',
  paddingTop: 12,
  paddingLeft: STEPS_PADDING,
  paddingRight: STEPS_PADDING,
  width: 232,
  flexShrink: 0,
  overflowY: 'auto' as const,
};
